import { orderActionTypes } from '@Actions/orderActions';

const OrderReducer = (state = { }, action) => {
  switch (action.type) {
    case orderActionTypes.GET_OPEN_ORDERS.LOADING: {
      const { getOpenOrdersLoading } = action;
      return {
        ...state,
        getOpenOrdersLoading,
      };
    }
    case orderActionTypes.GET_OPEN_ORDERS.SUCCESS: {
      const { openOrders } = action;
      return {
        ...state,
        openOrders,
      };
    }
    case orderActionTypes.GET_CLOSED_ORDERS.LOADING: {
      const { getClosedOrdersLoading } = action;
      return {
        ...state,
        getClosedOrdersLoading,
      };
    }
    case orderActionTypes.GET_CLOSED_ORDERS.SUCCESS: {
      const { closedOrders } = action;
      return {
        ...state,
        closedOrders,
      };
    }
    case orderActionTypes.GET_ORDER_BY_ID.LOADING: {
      const { getOrderByIdLoading } = action;
      return {
        ...state,
        getOrderByIdLoading,
      };
    }
    case orderActionTypes.GET_ORDER_BY_ID.SUCCESS: {
      const { selectedOrder } = action;
      return {
        ...state,
        selectedOrder,
      };
    }
    case orderActionTypes.CREATE_BULK_ORDER.LOADING: {
      const { createBulkOrderLoading } = action;
      return {
        ...state,
        createBulkOrderLoading,
      };
    }
    case orderActionTypes.CREATE_BULK_ORDER.SUCCESS: {
      const { showBulkOrderConfirmation } = action;
      return {
        ...state,
        showBulkOrderConfirmation,
      };
    }
    default: {
      return state;
    }
  }
};

export default OrderReducer;
